import { ShieldCheck } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useT } from '../i18n/t'

type MoneyBackGuaranteeProps = {
  /** Jasne tło (domyślnie) lub ciemne hero. */
  tone?: 'light' | 'dark'
  className?: string
  showTermsLink?: boolean
}

export function MoneyBackGuarantee({
  tone = 'light',
  className = '',
  showTermsLink = false,
}: MoneyBackGuaranteeProps) {
  const { t } = useT()

  const isDark = tone === 'dark'

  return (
    <p
      className={
        'flex max-w-[52ch] items-start gap-2.5 text-[14px] font-normal leading-relaxed md:text-[15px] ' +
        (isDark ? 'text-white/85' : 'text-ink/65') +
        (className ? ` ${className}` : '')
      }
    >
      <ShieldCheck
        className={
          'mt-0.5 h-[18px] w-[18px] shrink-0 ' + (isDark ? 'text-white/70' : 'text-ink/45')
        }
        aria-hidden="true"
      />
      <span>
        {t('trust.moneyBack.text')}{' '}
        {showTermsLink ? (
          <Link
            to="/regulamin"
            className={
              'font-medium underline decoration-current/30 underline-offset-4 transition hover:decoration-current/60 ' +
              (isDark ? 'text-white' : 'text-ink')
            }
          >
            {t('trust.moneyBack.termsLink')}
          </Link>
        ) : null}
      </span>
    </p>
  )
}
